export function publicEnv(name, buildValue, fallback = "") {
  const runtimeValue = typeof window !== "undefined"
    ? window.__EDAFACE_ENV__?.[name]
    : undefined;

  if (runtimeValue !== undefined && runtimeValue !== "") return runtimeValue;
  if (buildValue !== undefined && buildValue !== "") return buildValue;
  return fallback;
}

export function publicInteger(name, buildValue, fallback) {
  const value = Number(publicEnv(name, buildValue, String(fallback)));
  return Number.isSafeInteger(value) ? value : fallback;
}

export function publicIntegerList(name, buildValue, fallback = []) {
  const values = publicEnv(name, buildValue, fallback.join(","))
    .split(",")
    .map((value) => Number(value.trim()))
    .filter(Number.isSafeInteger);
  return values.length ? values : fallback;
}
